import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { FooterAttachmentData } from '../types'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { asText } from '@prismicio/client'
import CTAButton from './CTAButton'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

//sectionId is used for navigation
const FooterAttachmentSection: FC<{ data?: FooterAttachmentData; sectionId?: string }> = ({
  data,
  sectionId
}) => {
  if (!data) return null
  return (
    <Box
      display="block"
      backgroundColor="primary.black"
      p={{ _: '48px 28px 20px 28px', md: '52px' }}
      id={sectionId}
    >
      <PrismicText
        richTextField={data.primary?.header}
        variant="display/large"
        fontSize={{ _: '24px', md: '28px', lg: '32px' }}
        color="primary.white"
        textAlign="center"
        lineHeight={{ _: '30px', md: '40px' }}
      />
      {asText(data.primary?.subheader) && (
        <Box flexDirection="column" maxWidth="604px" justifyContent="center" mx="auto">
          <Spacer mt="16px" />
          <PrismicText
            richTextField={data.primary?.subheader}
            variant="body/large"
            fontSize={{ _: '14px', md: '16px', lg: '20px' }}
            color="primary.white"
            textAlign="center"
            lineHeight="24.5px"
          />
        </Box>
      )}
      <Spacer mb="42px" />
      <Box justifyContent="center">
        <CTAButton
          data-heap-id="FooterAttachmentSection_CTAButton"
          label={data.primary?.button_label}
          href={data.primary?.button_href?.url}
          variant={data.primary?.button_variant}
        />
      </Box>
    </Box>
  )
}

export default FooterAttachmentSection
